import { motion } from "framer-motion";
import { CountUp } from "./CountUp";
import { ArrowUpRight, Star } from "lucide-react";
import { CONTACT, GOOGLE_RATING, TESTIMONIALS } from "@/data/site";
import { Reveal, Eyebrow } from "./Reveal";

const Stars = ({ n }) => (
  <motion.span className="flex gap-0.5 text-[#B85C38]" initial="hidden" whileInView="show" viewport={{ once: true }} transition={{ staggerChildren: 0.08, delayChildren: 0.3 }}>
    {Array.from({ length: n }).map((_, i) => (
      <motion.span key={i} variants={{ hidden: { scale: 0, rotate: -30 }, show: { scale: 1, rotate: 0 } }} transition={{ type: "spring", stiffness: 400, damping: 16 }}><Star size={14} className="fill-current" /></motion.span>
    ))}
  </motion.span>
);

export const Testimonials = () => (
  <section id="testimonials" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-36" data-testid="testimonials-section">
    <div className="grid lg:grid-cols-12 gap-14 lg:gap-20">
      <Reveal className="lg:col-span-4">
        <Eyebrow className="mb-6">05 / Clients</Eyebrow>
        <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">What homeowners say</h2>
        <a href={CONTACT.google} target="_blank" rel="noopener noreferrer" className="group mt-10 flex items-center gap-5 border border-stone-200 bg-white p-6 hover:border-stone-900 transition-colors duration-300" data-testid="google-rating-card">
          <CountUp value={GOOGLE_RATING.score} className="font-serif text-6xl leading-none text-stone-900" /> 
          <span>
            <Stars n={5} />
            <span className="mt-2 block font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">{GOOGLE_RATING.count} reviews on Google</span>
            <span className="mt-1 flex items-center gap-1 text-sm text-stone-900 link-line">Carvings Architecture, Thalassery <ArrowUpRight size={14} /></span>
          </span>
        </a>
        <a href={CONTACT.googleReview} target="_blank" rel="noopener noreferrer" className="btn-ghost mt-6" data-testid="write-review-btn">Write a review <ArrowUpRight size={16} /></a>
      </Reveal>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-6 lg:gap-8 lg:pt-16">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.id} delay={0.05 * i} className="bg-[#F4F3EE] p-8 lg:p-10 flex flex-col">
            <article data-testid={`testimonial-${t.id}`} className="flex flex-col h-full">
              <Stars n={t.stars} />
              <blockquote className="mt-6 font-serif text-2xl lg:text-3xl leading-snug text-stone-900">“{t.text}”</blockquote>
              <footer className="mt-auto pt-8">
                <p className="text-stone-900">{t.name}</p>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500 mt-1">{t.meta}</p>
              </footer>
            </article>
          </Reveal>
        ))}
        <Reveal delay={0.1} className="border border-dashed border-stone-300 p-8 lg:p-10 flex flex-col justify-end">
          <p className="font-serif text-2xl text-stone-900 leading-snug">Built with Carvings?</p>
          <p className="mt-3 text-stone-600 font-light text-sm leading-relaxed">Your words help the next family find us. Leave a review on Google and we may feature it here.</p>
          <a href={CONTACT.googleReview} target="_blank" rel="noopener noreferrer" className="link-line mt-6 self-start font-mono text-xs uppercase tracking-[0.2em] text-stone-900" data-testid="testimonial-cta-link">Share your experience</a>
        </Reveal>
      </div>
    </div>
  </section>
);
